<template>
  <div>
    <el-dropdown
      split-button
      type="primary"
      size="small"
      @command="handleCommand"
      @click="handleCommandClick"
    >
      {{ command.name }}
      <el-dropdown-menu slot="dropdown">
        <el-dropdown-item :command="{ name: '创建需求开发广告', route: 'createGoogle' }">
          需求开发广告
        </el-dropdown-item>
        <el-dropdown-item :command="{ name: '创建搜索广告', route: 'createSearchAds' }">搜索广告</el-dropdown-item>
      </el-dropdown-menu>
    </el-dropdown>
  </div>
</template>
<script>
export default {
  data() {
    return {
      command: {
        name: '创建需求开发广告',
        route: 'createGoogle',
      },
    };
  },
  methods: {
    // 点击创建广告类型1
    // handleCommandClick() {
    //   this.handleCommand(this.adType);
    // },
    // 点击创建广告类型
    handleCommandClick() {
      this.handleCommand(this.command);
    },
    handleCommand(command) {
      this.command = { ...command };
      let currentAccount = JSON.parse(localStorage.getItem('createAdAccount'));
      this.$router.push({
        name: command.route,
        query: {
          account_id: currentAccount.accountId,
          credentialUserId: localStorage.getItem('googleCredentialUserId'),
        },
      });
    },
  },
};
</script>
<style lang="scss" scoped>
:deep(.el-dropdown-menu__item) {
  min-width: 120px;
  font-size: 14px;
  padding: 12px 20px;
  line-height: 1.2;
}
</style>
